// src/api/getTodayCandles.js
import axios from "axios";

/**
 * Get today's candlestick data from Delta Exchange
 * @param {string} symbol - e.g., "BTCUSD"
 * @param {string} resolution - e.g., "5m", "1h"
 * @returns {Promise<Object>} - API response
 */
export const getTodayCandles = async (symbol = "BTCUSD", resolution = "1m",daydata=7) => {
  try {
    // IF resolution 1m , 5m, 15m then show today data otherwise shoow last 2 days data
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0); // Set to start of today in UTC
    const startOfToday = Math.floor(today.getTime() / 1000); // Convert
    // to seconds since epoch
    const now = Math.floor(Date.now() / 1000); // current time in seconds
    const start =
      resolution === "1m" 
        ? startOfToday
        : startOfToday - daydata * 24 * 60 * 60; // Last 7 days in seconds

   

    const url = `https://api.india.delta.exchange/v2/history/candles?resolution=${resolution}&symbol=${symbol}&start=${start}&end=${now}`;

    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching candle data:", error);
    throw error;
  }
};


// src/api/getTodayCandles.js


// const validateAndCleanCandleData = (candles) => {
//   if (!candles || candles.length === 0) {
//     return [];
//   }

//   // Use Map to remove duplicates (keep last occurrence)
//   const uniqueCandles = new Map();
  
//   candles.forEach(candle => {
//     const time = Number(candle.time);
    
//     // Skip invalid candles
//     if (!time || time <= 0) return;
    
//     uniqueCandles.set(time, {
//       time: time,
//       open: Number(candle.open) || 0,
//       high: Number(candle.high) || 0,
//       low: Number(candle.low) || 0,
//       close: Number(candle.close) || 0,
//       volume: Number(candle.volume) || 0
//     });
//   });

//   // Convert to array and sort by time (ascending)
//   const sortedCandles = Array.from(uniqueCandles.values())
//     .sort((a, b) => a.time - b.time);

  
//   return sortedCandles;
// };


// const fetchFromTradingView = async (symbol, resolution, start, end) => {
//   try {
    
//     // TradingView resolution mapping
//     const tvResolution = {
//       "1m": "1m",
//       "5m": "5m",
//       "15m": "15m",
//       "30m": "30m",
//       "1h": "60m",
//       "4h": "240m",
//       "1d": "D"
//     };

//     // Symbol mapping for TradingView
//     const tvSymbolMap = {
//       "BTCINR": "WAZIRX:BTCINR",
//       "ETHINR": "WAZIRX:ETHINR",
//       "USDINR": "OANDA:USDINR",
//       "USDTINR": "WAZIRX:USDTINR",
//       "SOLINR": "WAZIRX:SOLINR",
//       "XRPINR": "WAZIRX:XRPINR"
//     };

//     const tvSymbol = tvSymbolMap[symbol.toUpperCase()] || `WAZIRX:${symbol.toUpperCase()}`;
//     const tvRes = tvResolution[resolution] || "60";

//     const url = `https://scanner.tradingview.com/crypto/scan`;
    
//     // Alternative: Use Binance for USDT pairs, TradingView for INR
//     if (symbol.includes("USDT")) {
//       // Use Binance for USDT pairs
//       const binanceSymbol = symbol.toUpperCase();
//       const binanceInterval = {
//         "1m": "1m",
//         "5m": "5m",
//         "15m": "15m",
//         "30m": "30m",
//         "1h": "1h",
//         "4h": "4h",
//         "1d": "1d"
//       }[resolution] || "1h";

//       const binanceUrl = `https://api.binance.com/api/v3/klines`;
      
//       const response = await axios.get(binanceUrl, {
//         params: {
//           symbol: binanceSymbol,
//           interval: binanceInterval,
//           startTime: start * 1000,
//           endTime: end * 1000,
//           limit: 1000
//         },
//         timeout: 10000
//       });

//       if (response.data && response.data.length > 0) {
        
//         const candles = response.data.map(candle => ({
//           time: Math.floor(candle[0] / 1000),
//           open: parseFloat(candle[1]),
//           high: parseFloat(candle[2]),
//           low: parseFloat(candle[3]),
//           close: parseFloat(candle[4]),
//           volume: parseFloat(candle[5])
//         }));

//         // Clean and validate
//         const cleanedData = validateAndCleanCandleData(candles);

//         return {
//           success: true,
//           result: cleanedData,
//           source: "binance"
//         };
//       }
//     }

//     // For INR pairs, use WazirX API (Indian Exchange)
//     if (symbol.includes("INR")) {
      
//       const wazirxSymbol = symbol.toLowerCase();
//       const wazirxUrl = `https://api.wazirx.com/sapi/v1/klines`;
      
//       const wazirxInterval = {
//         "1m": "1m",
//         "5m": "5m",
//         "15m": "15m",
//         "30m": "30m",
//         "1h": "1h",
//         "4h": "4h",
//         "1d": "1d"
//       }[resolution] || "1h";

//       const response = await axios.get(wazirxUrl, {
//         params: {
//           symbol: wazirxSymbol,
//           interval: wazirxInterval,
//           startTime: start * 1000,
//           endTime: end * 1000,
//           limit: 1000
//         },
//         timeout: 10000
//       });

//       if (response.data && response.data.length > 0) {
        
//         const candles = response.data.map(candle => ({
//           time: Math.floor(candle[0] / 1000),
//           open: parseFloat(candle[1]),
//           high: parseFloat(candle[2]),
//           low: parseFloat(candle[3]),
//           close: parseFloat(candle[4]),
//           volume: parseFloat(candle[5])
//         }));

//         // Clean and validate
//         const cleanedData = validateAndCleanCandleData(candles);

//         return {
//           success: true,
//           result: cleanedData,
//           source: "wazirx"
//         };
//       }
//     }

//     return null;
//   } catch (error) {
//     console.error(`❌ TradingView/WazirX/Binance failed:`, error.message);
//     return null;
//   }
// };


// export const getTodayCandles = async (
//   symbol = "BTCUSD",
//   resolution = "1m",
//   daydata = 7
// ) => {
//   const today = new Date();
//   today.setUTCHours(0, 0, 0, 0);
//   const startOfToday = Math.floor(today.getTime() / 1000);
//   const now = Math.floor(Date.now() / 1000);
//   const start = resolution === "1m" ? startOfToday : startOfToday - daydata * 24 * 60 * 60;

//   // ==========================================
//   // METHOD 1: Delta Exchange (USD pairs only)
//   // ==========================================
//   if (symbol.includes("USD") && !symbol.includes("USDT") && !symbol.includes("INR")) {
//     try {
//      
//       const deltaUrl = `https://api.india.delta.exchange/v2/history/candles?resolution=${resolution}&symbol=${symbol}&start=${start}&end=${now}`;
      
//       const deltaResponse = await axios.get(deltaUrl, {
//         headers: { Accept: "application/json" },
//         timeout: 10000,
//       });

//       if (deltaResponse.data?.result?.length > 0) {
//        
//         // Clean and validate Delta data
//         const cleanedData = validateAndCleanCandleData(deltaResponse.data.result);
        
//         return {
//           success: true,
//           result: cleanedData,
//           source: "delta"
//         };
//       }
//     } catch (deltaError) {
//       console.warn(`⚠️ Delta failed for ${symbol}:`, deltaError.message);
//     }
//   }

//   // ==========================================
//   // METHOD 2: WazirX (INR) / Binance (USDT)
//   // ==========================================
//   const tvData = await fetchFromTradingView(symbol, resolution, start, now);
//   if (tvData) {
//     return tvData;
//   }

//   // ==========================================
//   // METHOD 3: CoinGecko Fallback
//   // ==========================================
//   try {
    
//     const coinMap = {
//       "BTCUSD": "bitcoin",
//       "BTCUSDT": "bitcoin",
//       "BTCINR": "bitcoin",
//       "ETHUSD": "ethereum",
//       "ETHUSDT": "ethereum",
//       "ETHINR": "ethereum",
//       "SOLUSDT": "solana",
//       "SOLINR": "solana",
//       "XRPUSDT": "ripple",
//       "XRPINR": "ripple",
//       "TRXUSDT": "tron",
//       "DOGEUSD": "dogecoin",
//       "USDTINR": "tether",
//       "USDINR": "usd"
//     };

//     const coinId = coinMap[symbol.toUpperCase()];
    
//     if (!coinId) {
//       throw new Error(`Symbol ${symbol} not supported`);
//     }

//     const currency = symbol.includes("INR") ? "inr" : "usd";
//     const days = Math.min(daydata, 90);
    
//     const cgUrl = `https://api.coingecko.com/api/v3/coins/${coinId}/market_chart`;
    
//     const cgResponse = await axios.get(cgUrl, {
//       params: {
//         vs_currency: currency,
//         days: days,
//         interval: resolution === "1m" ? "minutely" : "hourly"
//       },
//       timeout: 10000,
//     });

//     if (cgResponse.data?.prices?.length > 0) {
//       
//       const resolutionMinutes = {
//         "1m": 1, "5m": 5, "15m": 15, "30m": 30,
//         "1h": 60, "4h": 240, "1d": 1440
//       };
      
//       const intervalMs = (resolutionMinutes[resolution] || 60) * 60 * 1000;
//       const candles = [];

//       cgResponse.data.prices.forEach(([timestamp, price]) => {
//         const candleTime = Math.floor(timestamp / intervalMs) * intervalMs;
//         const time = Math.floor(candleTime / 1000);

//         candles.push({
//           time: time,
//           open: price,
//           high: price,
//           low: price,
//           close: price,
//           volume: 0
//         });
//       });

//       // Clean and validate
//       const cleanedData = validateAndCleanCandleData(candles);

//       return {
//         success: true,
//         result: cleanedData,
//         source: "coingecko"
//       };
//     }
//   } catch (cgError) {
//     console.error(`❌ CoinGecko failed:`, cgError.message);
//   }

//   // ==========================================
//   // ALL FAILED
//   // ==========================================
//   console.error(`💥 ALL SOURCES FAILED for ${symbol}`);
  
//   return {
//     success: false,
//     result: [],
//     error: "No data available from any source",
//     source: "none"
//   };
// };

// export default getTodayCandles;